export const textFieldStyle = {
  '& label': {
    color: '#AAAAAA' // 通常時のラベル色
  },
  '& label.Mui-focused': {
    color: '#A08B64' // フォーカス時のラベル色
  },
  '& .MuiInput-underline:before': {
    borderBottomColor: '#CCCCCC' // 通常時のボーダー色
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottomColor: '#DDDDDD' // ホバー時のボーダー色
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#CCCCCC' // 通常時のボーダー色(アウトライン)
    },
    '&.Mui-focused fieldset': {
      borderColor: '#A08B64' // フォーカス時のボーダー色(アウトライン)
    }
  }
};
